const dateFormat = {
  DATE: 'DD MMM YYYY',
  MONTH_YEAR: 'MMM YYYY',
  SHORT_MONTH_YEAR: 'MM YYYY',
  YEAR: 'YYYY',
  SHORT_MONTH: 'MM',
};

export default dateFormat;
